import { Typography } from '@material-ui/core';
import '../../styles/Globales.scss';
import '../../styles/ProductosConfirmacion.scss';

import React, { Component } from 'react';
import SwitchComponent from './SwitchComponent';
import * as ValidationUtils from '../../utils/ValidationUtils';

export default class ProductoConfirmarComponent extends Component {
  onSwitchChange = (value) => {
    if (this.props.switchChange) {
      this.props.switchChange(value);
    }
  };

  renderProductos = (productos) => {
    const result = productos.map((item, index) => {
      return (
        <div key={index}>
          <div className="lineaCredito">
            <div className="lineaCreditoTitulo">
              <Typography className="tituloBold">{item.nombreProducto}</Typography>
            </div>
            <Typography>$ {ValidationUtils.formatMontoWithZero(item.monto)}</Typography>
          </div>
        </div>
      );
    });
    return result;
  };
  render() {
    return (
      <div className="ProductoConfirmar ">
        <div className="tituloProducto">
          <Typography className="tituloStepSolicitudAcordeon">{this.props.tituloProducto}</Typography>
          <div>
            <SwitchComponent checked={this.props.selected} onChange={this.onSwitchChange} />
          </div>
        </div>
        {this.renderProductos(this.props.productos)}
      </div>
    );
  }
}
